<script lang="ts">
    import type { RewardsTranslationNamespaces } from "@apps/rewards/constants/constants";
    import type RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import { REWARDS_SPENDING_RULES_REWARD_TYPES } from "@apps/rewards/modules/SpendingRules/constants";
    import type { RewardsSpendingRulesEntity } from "@apps/rewards/modules/SpendingRules/models/RewardsSpendingRulesEntities";
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";
    import type { Observable } from "rxjs";

    import T from "@components/T.svelte";

    import RewardsCurrency from "../RewardsCurrency.svelte";

    //Props
    export let reward: RewardsSpendingRulesEntity["rewards"][number];
    export let pointsPrice: number;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let sanitizer: HTMLSanitizerInterface;
    export let pointsName$: Observable<string>;
    export let namespace: RewardsTranslationNamespaces;

    const {
        fixedAmountDiscount,
        flexibleAmountDiscount,
        fixedPercentageDiscount,
        flexiblePercentageDiscount,
        giftCard,
        productDiscount,
        shippingDiscount,
    } = REWARDS_SPENDING_RULES_REWARD_TYPES;
</script>

{#if reward.rewardType === fixedAmountDiscount}
    <RewardsCurrency
        let:amount
        amount={reward.amount}
        rewardsCurrencyFormatter={currencyFormatter}
        {sanitizer}
    >
        <T
            {namespace}
            translationKey="spending_rules_fixed_amount_reward"
            translationOptions={{
                amount,
                points: pointsPrice,
                points_name: $pointsName$,
            }}
        />
    </RewardsCurrency>
{/if}
{#if reward.rewardType === flexibleAmountDiscount}
    <RewardsCurrency
        let:amount
        amount={reward.amountY}
        rewardsCurrencyFormatter={currencyFormatter}
        {sanitizer}
    >
        <T
            {namespace}
            translationKey="spending_rules_flexible_amount_reward"
            translationOptions={{
                amount,
                points: pointsPrice,
                points_name: $pointsName$,
            }}
        />
    </RewardsCurrency>
{/if}
{#if reward.rewardType === fixedPercentageDiscount}
    <T
        {namespace}
        translationKey="spending_rules_fixed_percentage_reward"
        translationOptions={{
            discount: reward.percents,
            points: pointsPrice,
            points_name: $pointsName$,
        }}
    />
{/if}
{#if reward.rewardType === flexiblePercentageDiscount}
    <T
        {namespace}
        translationKey="spending_rules_flexible_percentage_reward"
        translationOptions={{
            discount: reward.percentsY,
            points: pointsPrice,
            points_name: $pointsName$,
        }}
    />
{/if}
{#if reward.rewardType === giftCard}
    <RewardsCurrency
        let:amount
        amount={reward.initialValue}
        rewardsCurrencyFormatter={currencyFormatter}
        {sanitizer}
    >
        <T
            {namespace}
            translationKey="spending_rules_gift_card_reward"
            translationOptions={{
                amount,
                points: pointsPrice,
                points_name: $pointsName$,
            }}
        />
    </RewardsCurrency>
{/if}
{#if reward.rewardType === productDiscount}
    <T
        {namespace}
        translationKey="spending_rules_product_discount_reward"
        translationOptions={{
            points: pointsPrice,
            points_name: $pointsName$,
        }}
    />
{/if}
{#if reward.rewardType === shippingDiscount}
    <T
        {namespace}
        translationKey="spending_rules_free_shipping_reward"
        translationOptions={{
            points: pointsPrice,
            points_name: $pointsName$,
        }}
    />
{/if}
